import React, { memo } from "react";

export const FilterList = memo(({ handleFilterClick, filterList, activeFilterList }) => {
    const filters = [];
    for (const f of filterList) {
        filters.push(
            <div key={f.FilterLabelId} className="FilterCategory tk-trade-gothic-next-condensed tw-pl-[19px] tw-pr-[10px] md:tw-pl-[10px] md:tw-pr-0">
                <div className="ToggleBtn tw-cursor-pointer" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginRight: "9px" }} onClick={handleSign.bind(this)}>
                    <div className="FilterCategoryLabel tw-text-[20px]">{f.FilterLabel}</div>
                    <div className="ToggleBtnSign tw-text-tamarillo-700 tw-leading-[0px] "
                        style={{ fontSize: "34px", marginBottom: "7px" }}
                        data-filterid={f.FilterLabelId} >
                        +
                    </div>
                </div>

                <div className="FilterValues ThinScrollBarContainer hide tw-pb-[21px] tw-mt-[7px] tw-pr-[9px] md:tw-pr-0"
                    style={f.FilterLabel == "Color" ? { display: "flex", flexWrap: "wrap", columnGap: "3px", rowGap: "7px" } : {}}>
                    <Criteria f={f} handleFilterClick={handleFilterClick} activeFilterList={activeFilterList} />
                </div>
            </div>
        );
    }
    return filters;

    function handleSign(e) {
        const sign = $(e.currentTarget).find('.ToggleBtnSign');
        if (sign.html().trim() == "+") {
            sign.html("&#8212;");
            sign.css({ 'font-family': 'impact', 'font-size': '14px', 'margin-bottom': '0px' });
            sign.addClass('is-expanded');
        }
        else {
            sign.html("+");
            sign.css({ 'font-family': 'trade-gothic-next-condensed', 'font-size': '34px', 'margin-bottom': '7px' });
            sign.removeClass('is-expanded');
        }

        sign.closest('.FilterCategory').find('.FilterValues').toggleClass('hide');
    }
})

const Criteria = memo(({ f, handleFilterClick, activeFilterList }) => {

    const criteriaList = [];
    const longColors = ["Tactical Black", "TacticalBlack", "Black/White"];

    for (const criteria of f.FilterValues) {
        var isLongColor = !!longColors.filter((str) => str.toLowerCase() == criteria.FilterOptionLabel.toLowerCase()).length;
        const key = criteria.FilterKey.trim();
        f.FilterLabel == "Color" ?
            criteriaList.push(
                <div key={key} id={key} className="form-check tw-flex tk-trade-gothic-next tw-items-center tw-ml-[4px] tw-min-w-[100px] tw-cursor-pointer tw-basis-[47.6%] tw-py-[5px] tw-pl-[8px] tw-gap-[8px]"
                    style={key in activeFilterList ? { border: "2px solid #282828"} : {border: "1px solid #E0E0E0"}}
                    onClick={(e) => handleFilterClick(e)} data-filterkey={key} data-filteroption={criteria.FilterOptionLabel} data-iscolor={true}>

                    <input type="checkbox" className={"FilterCheckbox tw-z-[-1] tw-cursor-pointer " + criteria.FilterOptionLabel.toLowerCase().replaceAll(' ', '-').replaceAll('/', '-') + " filterColors"} />

                    <div htmlFor="flexCheckDefault" className={"form-check-label FilterOptionLabel " + (isLongColor ? "tw-text-[11px] md:tw-text-[10px]" : "tw-text-[15px] md:tw-text-[14px]")}>
                        {criteria.FilterOptionLabel + ' (' + criteria.MatchCount + ')'}
                    </div>
                </div>
            )
            : criteriaList.push(
                <div key={key} id={key} className="form-check tw-flex tk-trade-gothic-next tw-items-center tw-ml-[4px] tw-min-w-[100px] tw-cursor-pointer tw-mt-[8px] tw-pl-[0px] tw-gap-[10px]"
                    onClick={(e) => handleFilterClick(e)} data-filterkey={key} data-filteroption={criteria.FilterOptionLabel} data-iscolor={false}>

                    <input className="FilterCheckbox tw-cursor-pointer filterNoColor tw-z-[-1]" type="checkbox" checked={key in activeFilterList} readOnly />

                    <div htmlFor="flexCheckDefault" className="form-check-label FilterOptionLabel tw-text-[15px]"
                        style={key in activeFilterList ? {fontWeight:"bold"} : {} }>
                        {criteria.FilterOptionLabel + ' (' + criteria.MatchCount + ')'}
                    </div>
                </div>
            );
    }
    return criteriaList;
})